import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-by-product-order-confirm',
  templateUrl: './by-product-order-confirm.component.html',
  styleUrls: ['./by-product-order-confirm.component.scss']
})
export class ByProductOrderConfirmComponent implements OnInit {
  final_price: any;
  final_price_before_rounded: any;
  roundoff_value: any;
  product_list: any = [];
  disable_button = false;
  final_data: any = {};
  wallet_balance = 0;
  final_wallet_balance = 0;
  final_price_after_wallet = null;
  selected_order_category_id = 2;
  is_wallet_selected = true;
  order_category: any;
  business_type_id = null;
  payment_method_list = [];
  payment_method_id = null;


  constructor(public dialogRef: MatDialogRef<ByProductOrderConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data, private http: HttpService, private global: GlobalService) {
    const data_dict = {
      'from': 'portal',
      'business_code': data['business_code']
    };
    this.http.serveWalletBalanceAndOrderCategory(data_dict).subscribe((data) => {
      this.wallet_balance = data['wallet_balance'];
      this.order_category = data['order_category'];
      this.business_type_id = data['business_type_id'];
      console.log(this.final_data);
      console.log(data);
    }, (error) => {
      console.error(error);
    });
    this.http.servePaymentMethod().subscribe((data: any) => {
      console.log(data);
      this.payment_method_list = data;
    }, (error) => {
      console.error(error);
    });
    this.final_price = data['final_price'];
    this.final_price_before_rounded = data['final_price_before_rounded'];
    this.roundoff_value = data['roundoff_value'];
    this.product_list = data['product_list'];
    this.final_data = data;


    setTimeout(() => document.getElementById('register_button').focus(), 500);
  }

  checkForDisable() {
    if (this.disable_button) {
      return true;
    } else if (this.payment_method_id == null) {
      return true;
    } else {
      return false;
    }
  }

  finalizeCalled() {
    console.log(this.business_type_id)
    if (this.business_type_id == 14) {
      this.orderForEmployeeCalled();
    } else {
      this.payClicked();
    }
  }

  orderForEmployeeCalled() {
    let data_dict = {
      'selected_product_list': this.final_data['product_list'],
      'final_wallet': this.wallet_balance,
      'final_price': this.final_data['final_price'],
      'final_price_before_rounded': this.final_data['final_price_before_rounded'],
      'roundoff_value': this.final_data['roundoff_value'],
      'final_price_before_wallet': this.final_data['final_price'],
      'from': 'portal',
      'is_wallet_selected': this.is_wallet_selected,
      'business_code': this.final_data['business_code']
    };
    this.http.registerOrderForByProductEmployee(data_dict).subscribe((data) => {
      console.log(data);
      let data_dict = {}
      let return_data = {
        'is_compleated': true,
        'data': data
      };
      this.closeComponent(return_data);
    }, (error) => {
      let error_data = error['error'];
      console.error(error);
      let return_data = {
        'is_compleated': true,
      };
      if (error_data.hasOwnProperty('available_qty')) {
        alert('You required ' + error_data['required_qty'] + ' of ' + error_data['product_name'] + '. But Available Qty is ' + error_data['available_qty']);
      }
      this.closeComponent(return_data);
    });
  }


  payClicked() {
    let data_dict = {
      'selected_product_list': this.final_data['product_list'],
      'final_wallet': this.wallet_balance,
      'final_price': this.final_data['final_price'],
      'final_price_before_wallet': this.final_data['final_price'],
      'from': 'portal',
      'is_wallet_selected': this.is_wallet_selected,
      'business_code': this.final_data['business_code'],
      'final_price_before_rounded': this.final_data['final_price_before_rounded'],
      'roundoff_value': this.final_data['roundoff_value'],
      'payment_method_id': this.payment_method_id,
    };
    this.http.registerOrderForByProductAgent(data_dict).subscribe((data) => {
      console.log(data);
      let return_data = {
        'is_compleated': true,
        'data': data
      };
      this.closeComponent(return_data);
    }, (error) => {
      let error_data = error['error'];
      console.error(error);
      let return_data = {
        'is_compleated': true,
      };
      if (error_data.hasOwnProperty('available_qty')) {
        alert('You required ' + error_data['required_qty'] + ' of ' + error_data['product_name'] + '. But Available Qty is ' + error_data['available_qty']);
      }
      this.closeComponent(return_data);
    });
  }

  ngOnInit() {
  }

  closeComponent(data: any = null) {
    if (data == null) {
      data = {
        'is_compleated': false,
      };
    }
    this.dialogRef.close(data);
  }
}
